import http from './http';

// 查询交易状态
export const fetchQueryTransactions = (params) => {
  return http({
    url: `/transactions/${params.orderNo}/status`,
  });
};

// 科目管理、消费项
export const fetchConsumptionItem = () => {
  return http({
    url: `/subject/buy`,
  });
};

// 前台消费业务
export const fetchFrontConsume = (data) => {
  return http({
    method: 'POST',
    url: `/transactions/reception/consume`,
    data,
  });
};

// 查询前台业务
export const fetchQueryFrontConsume = (data) => {
  return http({
    method: 'POST',
    url: `/transactions/search/page`,
    data,
  });
};

// 更新前台备注
export const fetchUpdateFrontConsume = (data) => {
  return http({
    method: 'POST',
    url: `/transactions/remark`,
    data,
  });
};

// 更新退款单备注
export const fetchUpdateRefoundConsume = (data) => {
  return http({
    method: 'POST',
    url: `/transactions/remark/refund`,
    data,
  });
};

// 退款列表
export const fetchRefundPage = (data) => {
  return http({
    method: 'POST',
    url: `/bills/items/refund/search/page`,
    data,
  });
};

// 退款强制成功
export const fetchForceToRefundSuccess = (data) => {
  return http({
    method: 'POST',
    url: `/bills/items/refund/coerce/success`,
    data,
  });
};

// 退款重试
export const fetchRetryRefund = (data) => {
  return http({
    method: 'POST',
    url: `/bills/items/refund/retry`,
    data,
  });
};

// 查询前台交易订单详情
export const fetchQueryOrderDetail = (params) => {
  return http({
    url: `/transactions/${params.no}/detail`,
  });
};

// 查询前台业务订单可退金额
export const fetchQueryRefoundable = (params) => {
  return http({
    url: `/transactions/${params.no}/refundable`,
  });
};

// 通用退款接口
export const refoundApi = (data) => {
  return http({
    method: 'POST',
    url: `/transactions/refund`,
    data,
  });
};

// 查询前台 订单商品明细
export const fetchGoodsDetail = (params) => {
  return http({
    url: `/transactions/${params.no}/goods/detail`,
  });
};

// 商品退货退款接口
export const goodsRefoundApi = (data) => {
  return http({
    method: 'POST',
    url: `/transactions/goods-refund`,
    data,
  });
};

// 查询订单是否过夜审
export const getOrderIsCrossNight = (params) => {
  return http({
    url: `/transactions/${params.no}/valid`,
  });
};

// 查询前台业务订单付款信息
export const getConsumeOrderPayDetail = (orderNo) => {
  return http({
    method: 'GET',
    url: `/transactions/${orderNo}/consume`,
  });
};
